import { render, staticRenderFns } from "./LLandingVersion.vue?vue&type=template&id=6dc03762&"
import script from "./LLandingVersion.vue?vue&type=script&lang=ts&"
export * from "./LLandingVersion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports